import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=013b2fca&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaField.vue?vue&type=style&index=0&id=013b2fca&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013b2fca')) {
      api.createRecord('013b2fca', component.options)
    } else {
      api.reload('013b2fca', component.options)
    }
    module.hot.accept("./TextAreaField.vue?vue&type=template&id=013b2fca&", function () {
      api.rerender('013b2fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/textarea/TextAreaField.vue"
export default component.exports